import { Tag } from 'antd';
export function renderTitle(title, color) {
  return <Tag color={color ?? 'geekblue'} className="ant-tag-search">
      {title}
    </Tag>;
}